<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-divider>确认发票信息</van-divider>

            <van-cell-group>

                <van-field
                        v-model="row.fapiao_taitou"
                        :rules="[{ required: true, message: '发票抬头不能为空' }]"
                        label="发票抬头"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入发票抬头"
                />
                <van-field
                        v-model="row.fapiao_shuihao"
                        :rules="[{ required: true, message: '税号不能为空' }]"
                        label="税号"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入税号"
                />
                <div class="operate-desc-left">如果您所在的单位没有纳税人识别号请填写“无”</div>

                <van-field
                        v-model="row.fapiao_address"
                        label="地址"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方地址"
                />
                <van-field
                        v-model="row.fapiao_tel"
                        label="电话"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方电话"
                />
                <van-field
                        v-model="row.fapiao_account"
                        label="开户行及账号"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方开户行及账号"
                />

                <van-field
                        v-model="row.fapiao_beizhu"
                        label="发票备注"
                        input-align="right"
                        clearable
                        placeholder="请输入发票备注"
                />
                <van-field
                        v-model="row.fapiao_email"
                        :rules="[{ validator: validator.email, message: '请输入正确的邮箱' }]"
                        error-message-align="right"
                        label="接收邮箱"
                        input-align="right"
                        clearable
                        placeholder="请输入接收邮箱"
                />
                <van-field
                        v-model="row.fapiao_phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="接送手机"
                        input-align="right"
                        clearable
                        placeholder="请输入接送手机"
                />

                <div class="fapiao-tip-wrap">
                    <div>
                        发票明细1 金额：{{parseInt(row.order.pay_price)-parseInt(row.order.shisuprice)}}元  名目：体育赛事综合服务费
                    </div>
                    <div v-show="row.order.shisuprice>0">
                        发票明细2 金额：{{row.order.shisuprice}}元  名目：代订食宿费
                    </div>
                </div>
                <div style="height: 0.2rem"></div>
                <div style="text-align: center" v-show="false">
                    <van-button
                            style="width: 3rem; margin: 10px;"
                            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">确认发票信息</van-button>
                </div>

            </van-cell-group>



            <div class="savebtn"
                 v-if="row.fapiao_status==0">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round   @click="submit">申请开票</van-button>
            </div>

        </van-form>

        <div class="savebtn"
             v-if="row.fapiao_status==2">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click.stop="download">发票下载</van-button>
        </div>
        <div class="savebtn"
             v-if="row.fapiao_status==3">
            <van-button
                    style="width: 3rem"
                    size="normal" round   @click.stop="showError()">开票失败(原因)</van-button>
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round   @click.stop="refresh()">刷新</van-button>
        </div>
        <div class="savebtn"
             v-if="row.fapiao_status==1">
            <van-button
                    style="width: 3rem"
                    size="normal" round   >开票中</van-button>
        </div>



        <van-popup v-model="showFapiao" style="width: 80%; height: auto ; text-align: center">
            <img :src="fapiaoUrl"  style="width: 100%; text-align: center; height: auto"  />
            <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
            <van-button v-else @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载</van-button>
            <!-- <van-button   @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载</van-button> -->
        </van-popup>
        <van-overlay :show="loading"    >
            <van-loading type="spinner" v-model="loading" style="text-align: center ; margin-top: 200px;" />
        </van-overlay>

 


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button,Dialog} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFapiao',
        components: {
            [Field.name]: Field,
            PicUploader,
            Dialog,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                loading:false,
                showFapiao:false,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                filename:'',
                fapiaoUrl:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{

                    }
                },
                isApp:window.isApp()
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            showError(){
                Toast.fail(this.row.fapiao.error_msg);
            },
            onSubmit(values){
                let that = this;
                Dialog.confirm({
                    title: '确认',
                    message: '请确认开票信息，开出后不得修改',
                })
                    .then(() => {
                        // on confirm
                        console.log('onSubmit-values',values);
                        console.log('submitType',this.submitType);
                        console.log(that.formData)
                        that.formValidate = true;
                        for (let field in that.formData) {

                        }
                        that.saveLoading = true;

                        that.$api.post('/api/isai/fapiaoapply',{
                            id : that.row.id,
                            fapiao_taitou : that.row.fapiao_taitou,
                            fapiao_shuihao : that.row.fapiao_shuihao,
                            fapiao_address : that.row.fapiao_address,
                            fapiao_tel : that.row.fapiao_tel,
                            fapiao_account : that.row.fapiao_account,
                            fapiao_beizhu : that.row.fapiao_beizhu,
                            fapiao_email : that.row.fapiao_email,
                            fapiao_phone : that.row.fapiao_phone,
                        },(res) => {
                            that.saveLoading = false;
                            Toast('申请开票中，请等待5分钟后重新打开该页面，即可下载发票');
                            setTimeout(() =>{
                                rbLink({
                                    name:'SaiApplyList'
                                },'back')
                            },5000);
                        }, (res) => {
                            Toast.fail(res.msg);
                            that.saveLoading = false;
                        })
                    })
                    .catch(() => {
                        // on cancel
                    });

            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/sai/fapiaodetail', {
                    id:that.row.id
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },
            download(){
                let that =this;
                that.loading = false;
                that.showFapiao = true;
                that.fapiaoUrl = that.row.fapiao.pic_url;
                that.filename = that.row.fapiao_taitou+'发票';
            },
            appDownload(){
                let that = this;
                console.log('downloadFile');
                appEvent({
                    name: 'downloadFile',
                    query: {
                        name: that.filename+'.jpg',
                        url:that.fapiaoUrl,
                    }
                });
            },
            refresh(){ 
                let that = this;
                that.$api.post('/api/fapiao/refreshFapiao', {
                    fapiao_id:that.row.fapiao.id
                }, (res) => { 
                    Toast('刷新成功');
                    that.fetch();
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFapiao.vue?7518cb0d